<script setup lang="ts">
const { loggedIn } = useUserSession()

useSeoMeta({
    title: 'Groceries — Senarai Belanja Pintar dengan AI',
})
</script>

<template>
    <div class="space-y-5 py-4">
        <section class="hero relative overflow-hidden text-center">
            <span class="kicker inline-flex items-center gap-2">
                <span
                    class="size-2 rounded-full"
                    :style="{
                        background: 'var(--green)',
                        boxShadow: '0 0 0 0 rgba(23,138,90,.42)',
                    }"
                />
                Senarai belanja pintar
            </span>
            <h1
                class="mx-auto mt-5 max-w-[980px] text-[clamp(32px,6.4vw,72px)] font-extrabold leading-[.91] tracking-[-.075em]"
            >
                Senarai belanja pintar,<br >
                <span :style="{ color: 'var(--green)' }">kongsi & siap sama-sama.</span>
            </h1>
            <p
                class="mx-auto mt-4 max-w-[660px] text-[15px] leading-relaxed"
                :style="{ color: 'var(--muted)' }"
            >
                Buat senarai groceries dengan bantuan AI, kongsi link dengan family — semua orang
                boleh tick item secara live, tak payah login pun.
            </p>

            <div class="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
                <NuxtLink
                    :to="loggedIn ? '/lists/create' : '/demo'"
                    class="btn-primary !min-h-[48px] !px-6 text-base"
                >
                    {{ loggedIn ? 'Buat senarai baru' : 'Cuba dulu' }}
                </NuxtLink>
                <NuxtLink
                    v-if="!loggedIn"
                    to="/auth/login"
                    class="btn !min-h-[48px] !px-6 text-base"
                >
                    Log masuk
                </NuxtLink>
            </div>
        </section>

        <section class="grid gap-3 sm:grid-cols-3" aria-label="Ciri-ciri">
            <div
                class="card py-8 text-center"
                :style="{
                    background:
                        'linear-gradient(135deg, var(--panel-soft), color-mix(in srgb, var(--blue-soft), transparent 22%))',
                }"
            >
                <p class="kicker">AI</p>
                <h2 class="mt-2 text-xl font-bold tracking-tight">Pembantu AI</h2>
                <p class="mt-1 text-sm" :style="{ color: 'var(--muted)' }">
                    "Barang dapur untuk seminggu, family 4 orang" — AI siapkan senarai lengkap
                    dengan kategori.
                </p>
            </div>
            <div
                class="card py-8 text-center"
                :style="{
                    background:
                        'linear-gradient(135deg, var(--panel-soft), color-mix(in srgb, var(--green-soft), transparent 22%))',
                }"
            >
                <p class="kicker">Live</p>
                <h2 class="mt-2 text-xl font-bold tracking-tight">Live & kolaboratif</h2>
                <p class="mt-1 text-sm" :style="{ color: 'var(--muted)' }">
                    Kongsi link, semua orang nampak perubahan serta-merta. Siapa beli apa, semua
                    jelas.
                </p>
            </div>
            <div class="card py-8 text-center">
                <p class="kicker">Mobile</p>
                <h2 class="mt-2 text-xl font-bold tracking-tight">Mesra telefon</h2>
                <p class="mt-1 text-sm" :style="{ color: 'var(--muted)' }">
                    Direka untuk guna sebelah tangan masa tolak troli. Mod gelap pun ada.
                </p>
            </div>
        </section>
    </div>
</template>
